import { useNavigate } from 'react-router-dom'
import AppCard from 'ui/AppCard'

const PlannedEventsCard = () => {
	const navigate = useNavigate()

	return (
		<AppCard
			title='Плановые события по здоровью'
			description='Настройте автоматическое формирование плановых дат обрезок копыт.'
			onClick={() => navigate('/settings/planned-events')}
		/>
	)
}

export default PlannedEventsCard
